import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const carouselDefaultVariants = {
  "arrowPosition": "outside"
}
const carouselCompoundVariants = []

const carouselSlotNames = [
  [
    "root",
    "Carousel__root"
  ],
  [
    "arrowWrapper",
    "Carousel__arrowWrapper"
  ],
  [
    "slide",
    "Carousel__slide"
  ],
  [
    "inner",
    "Carousel__inner"
  ],
  [
    "scrollContainer",
    "Carousel__scrollContainer"
  ]
]
const carouselSlotFns = /* @__PURE__ */ carouselSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, carouselDefaultVariants, getSlotCompoundVariant(carouselCompoundVariants, slotName))])

const carouselFn = memo((props = {}) => {
  return Object.fromEntries(carouselSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const carouselVariantKeys = [
  "arrowPosition"
]
const getVariantProps = (variants) => ({ ...carouselDefaultVariants, ...compact(variants) })

export const carousel = /* @__PURE__ */ Object.assign(carouselFn, {
  __recipe__: false,
  __name__: 'carousel',
  raw: (props) => props,
  variantKeys: carouselVariantKeys,
  variantMap: {
  "arrowPosition": [
    "outside",
    "inside"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, carouselVariantKeys)
  },
  getVariantProps
})